import CantileverButton, {
  AddButton,
  ChevronButton,
  EditButton,
} from 'components/CantileverButton'
import CantileverCard from 'components/CantileverCard'
import { AssetOverviewEditorGate } from 'features/assetDatabase'
import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { GeckoFeatureModelType } from 'types'

const ViewModeButtonsContainer = styled.div`
  display: flex;
  gap: 0.25rem;
`

interface FeatureAccordionHeaderProps {
  tableTitle: string
  addName: string
  featureType: GeckoFeatureModelType
  componentID: string
  disableEditing: boolean
  handleCollapsedViewChange: () => void
  handleSave: (formRef?: React.RefObject<HTMLFormElement>) => void
  handleEdit: (formId: string) => void
  handleCancel: (formId: string) => void
  handleAddFeature: (
    componentID: string,
    featureType: GeckoFeatureModelType
  ) => void
  inCollapsedView: boolean
  inEditMode: boolean
  inResolveMode: boolean
  isMissingDerivedLayerFields: boolean
}

export const FeatureAccordionHeader = forwardRef<
  HTMLFormElement,
  FeatureAccordionHeaderProps
>(
  (
    {
      tableTitle,
      featureType,
      componentID,
      addName,
      disableEditing,
      handleCollapsedViewChange,
      handleSave,
      handleEdit,
      handleAddFeature,
      handleCancel,
      inCollapsedView,
      inEditMode,
      inResolveMode,
      isMissingDerivedLayerFields,
    },
    ref
  ) => {
    const isWarning = inResolveMode && isMissingDerivedLayerFields
    return (
      <>
        <CantileverCard.SectionHeader
          leadingContent={
            inEditMode ? (
              <CantileverButton
                onClick={() => handleCancel(`${featureType}_${componentID}`)}>
                Cancel
              </CantileverButton>
            ) : (
              tableTitle
            )
          }
          trailingContent={
            inEditMode ? (
              <AssetOverviewEditorGate>
                <AddButton
                  onClick={() => {
                    handleAddFeature(componentID, featureType)
                  }}
                  entityName={addName}
                />
                <CantileverButton
                  primary
                  onClick={() =>
                    handleSave(ref as React.RefObject<HTMLFormElement>)
                  }>
                  Save
                </CantileverButton>
              </AssetOverviewEditorGate>
            ) : (
              <ViewModeButtonsContainer>
                {isWarning ? (
                  <AssetOverviewEditorGate>
                    <EditButton
                      warning
                      onClick={() =>
                        handleEdit(`${featureType}_${componentID}`)
                      }
                      disabled={disableEditing}
                    />
                  </AssetOverviewEditorGate>
                ) : (
                  <AssetOverviewEditorGate>
                    <CantileverCard.HiddenUnlessHovering>
                      <EditButton
                        ghost
                        onClick={() =>
                          handleEdit(`${featureType}_${componentID}`)
                        }
                        disabled={disableEditing}
                      />
                    </CantileverCard.HiddenUnlessHovering>
                  </AssetOverviewEditorGate>
                )}
                <ChevronButton
                  isCollapsed={inCollapsedView}
                  onClick={handleCollapsedViewChange}
                />
              </ViewModeButtonsContainer>
            )
          }
        />
      </>
    )
  }
)

FeatureAccordionHeader.displayName = 'FeatureAccordionHeader'
